import ApiService from '~~commonAPIs/ApiService';

const Local = {
  getVideoURL: (videoPath) => {
    return ApiService.get(`/api/local_video/${videoPath}`);
  },
};

export default Local;
